import {
  COLOR_DICTIONARY as TEXT_COLOR,
  // OPACITY as TEXT_OPACITY,
} from "@gcloud-npm/utils.enums.colors";

export const LABEL_SHAPES = {
  SQUARE: "square",
  TEARS: "tears",
  ROOF: "roof",
};

export const LABEL_TYPES = {
  PROMOCION: "promocion",
  INFORMACION: "informacion",
  ACTIVE: "active",
  INACTIVE: "inactive",
  SUCCESS: "success",
  WARNING: "warning",
  ERROR: "error",
  PROMOCION_INVERSE: "promocion-inverse",
  INFORMACION_INVERSE: "informacion-inverse",
  ACTIVE_INVERSE: "active-inverse",
  INACTIVE_INVERSE: "inactive-inverse",
  SUCCESS_INVERSE: "success-inverse",
  WARNING_INVERSE: "warning-inverse",
  ERROR_INVERSE: "error-inverse",
  RECOMENDADO: "recomendado",
  CONTRATADO: "contratado",
};

export const LABEL_STYLES = {
  [LABEL_TYPES.PROMOCION]: {
    color: TEXT_COLOR.MOVISTAR_WHITE,
  },
  [LABEL_TYPES.PROMOCION_INVERSE]: {
    color: TEXT_COLOR.RED_DARK,
  },
  [LABEL_TYPES.INFORMACION]: {
    color: TEXT_COLOR.MOVISTAR_WHITE,
  },
  [LABEL_TYPES.INFORMACION_INVERSE]: {
    color: TEXT_COLOR.MOVISTAR_BLACK,
  },
  [LABEL_TYPES.ACTIVE]: {
    color: TEXT_COLOR.BLUE_HIGH,
  },
  [LABEL_TYPES.ACTIVE_INVERSE]: {
    color: TEXT_COLOR.MOVISTAR_BLUE,
  },
  [LABEL_TYPES.INACTIVE]: {
    color: TEXT_COLOR.GREY_500,
  },
  [LABEL_TYPES.INACTIVE_INVERSE]: {
    color: TEXT_COLOR.GREY_500,
  },
  [LABEL_TYPES.SUCCESS]: {
    color: TEXT_COLOR.EMERALD,
  },
  [LABEL_TYPES.SUCCESS_INVERSE]: {
    color: TEXT_COLOR.GREEN_DARK,    
  },
  [LABEL_TYPES.WARNING]: {
    color: TEXT_COLOR.ORANGE,
    // opacity: TEXT_OPACITY[80],
  },
  [LABEL_TYPES.WARNING_INVERSE]: {
    color: TEXT_COLOR.ORANGE,
    // opacity: TEXT_OPACITY[80],
  },
  [LABEL_TYPES.ERROR]: {
    color: TEXT_COLOR.RED_DARK,
  },
  [LABEL_TYPES.ERROR_INVERSE]: {
    color: TEXT_COLOR.RED_DARK,
  },
  [LABEL_TYPES.RECOMENDADO]: {
    color: TEXT_COLOR.MOVISTAR_WHITE,
  },
  [LABEL_TYPES.CONTRATADO]: {
    color: TEXT_COLOR.GREEN_DARK,    
  },
};
